import React, { Component } from 'react';
import './style.sass';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallText from '../../../common-components/common-small-text';

const list = [
    {
        showDataTitle: '2',
        showDataSubtitle: 'года работы, которая ведется до&nbsp;сих пор',
    },
    {
        showDataTitle: '1 000+',
        showDataSubtitle: 'часов работы над проектом',
    },
    {
        showDataTitle: '2 036',
        showDataSubtitle: 'коммитов в&nbsp;проекте',
    },
];

class Results extends Component {
    render() {
        return (
            <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1.5}>
                <FullWrapper className="gge-digit" smallPaddings={true}>
                    <CommonTitle>Цифры</CommonTitle>
                    <div className="gge-digit-ciphers">
                        <div className="gge-digit-ciphers__wrapper">
                            <div className="gge-digit-ciphers__grid">
                                {list.map(({ showDataTitle, showDataSubtitle }, index) => (
                                    <ScrollAnimation
                                        animateIn="fadeInUp"
                                        offset={0}
                                        delay={100}
                                        animateOnce={true}
                                        duration={1}
                                        className="gge-digit-ciphers__item"
                                        key={index}
                                    >
                                        <div className="gge-digit-ciphers__item-wrap">
                                            <div className="gge-digit-ciphers__name">
                                                {showDataTitle}
                                            </div>
                                            <CommonSmallText className="gge-digit-ciphers__desc">
                                                <p
                                                    dangerouslySetInnerHTML={{
                                                        __html: showDataSubtitle,
                                                    }}
                                                ></p>
                                            </CommonSmallText>
                                        </div>
                                    </ScrollAnimation>
                                ))}
                            </div>
                        </div>
                    </div>
                </FullWrapper>
            </ScrollAnimation>
        );
    }
}

export default Results;
